import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import ThemeProvider from "react-bootstrap/ThemeProvider";
import "./App.css";
import { AppRoutes } from "./AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import { StepperProvider } from "./context/stepperContext";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(false);
  }, [isLoggedIn]);

  //const routing = useRoutes(AppRoutes(isLoggedIn, ''));

  return (
    <AuthProvider>
      <StepperProvider>
        <ThemeProvider
          breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
          minBreakpoint="xxs"
        >
          <div className="App">
            <AppRoutes />
          </div>
        </ThemeProvider>
      </StepperProvider>
    </AuthProvider>
  );
};

export default App;
